










































import { createOrUpdateClient, getSmsTags } from '@/api/Sms/sms.api'
import Autocomplete from '@/components/Autocomplete.vue'
import CreateDialog from '@/components/CreateDialog.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import { Params, VueForm } from '@/utils/interfaces'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import mixins from 'vue-typed-mixins'

export default mixins(crudMixin, editMixin).extend({
  components: { appCreateDialog: CreateDialog, PhoneTextField, Autocomplete },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {},
      defaultCrud: {
        first_name: '',
        last_name: '',
        phone: '',
        tags: [],
      },
      loading: false,
      getSmsTags: (params?: Params) => getSmsTags({ ...params, limit: 100 }),
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const response = await createOrUpdateClient(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
  },
})
